import { render, staticRenderFns } from "./connect_account.vue?vue&type=template&id=373c5d50&"
import script from "./connect_account.vue?vue&type=script&lang=js&"
export * from "./connect_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports